import { ChevronRight, ChevronDown, MoreVertical, Plus, Edit, Trash2 } from 'lucide-react';
import { useState } from 'react';

export default function MenuItem({ 
  item, 
  level = 0,
  toggleExpand,
  updatePermission,
  toggleEnabled,
  setCurrentParentId,
  setShowAddSubMenuModal,
  permissionsList,
  onEdit,
  onDelete
}) {
  const paddingLeft = level * 24;
  const [showActions, setShowActions] = useState(false);
   function getGridColsClass(length) {
  const maxCols = 12; // Optional: cap the max number of columns
  const colCount = Math.min(length, maxCols);
  return `grid-cols-${colCount}`;
}
  
  return (
    <>
      <div className="flex items-center border-b border-gray-200 bg-white">
        <div 
          className="flex items-center py-2 w-60"
          style={{ paddingLeft: `${paddingLeft}px` }}
        >
          <div className="flex items-center">
            {item.children && item.children.length > 0 ? (
              <button 
                onClick={() => toggleExpand(item.id)}
                className="mr-1 p-1 rounded-md hover:bg-gray-100"
              >
                {item.expanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
              </button>
            ) : (
              <div className="w-6 mr-1"></div>
            )}
            <span>{item.name}</span>
          </div>
        </div>
        
       <div className={`flex-1 grid gap-4 ${getGridColsClass(permissionsList.length)}`}>
          {permissionsList.map((permission) => (
            <div key={permission.id} className="flex justify-center items-center">
              <input 
                type="checkbox" 
                checked={item.enabled ? (item.permissions[permission.name.toLowerCase()] || false) : false}
                onChange={(e) => {
                    if (item.enabled) {
                      updatePermission(
                        item.id, 
                        permission.name.toLowerCase(), 
                        e.target.checked, 
                        true,
                        true
                      );
                    }
                  }}
                className={`h-4 w-4 ${!item.enabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                disabled={!item.enabled}
              />
            </div>
          ))}
        </div>
        
        <div className="w-20 flex items-center justify-center">
          <div 
            className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer ${item.enabled ? 'bg-blue-500' : 'bg-gray-300'}`}
            onClick={() => toggleEnabled(item.id)}
          >
            <div className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-200 ${item.enabled ? 'translate-x-6' : 'translate-x-0'}`}></div>
          </div>
        </div>
        
        {/* <div className="w-24 flex items-center justify-center relative">
          <button 
            onClick={() => setShowActions(!showActions)}
            className="p-1 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md"
          >
            <MoreVertical size={18} />
          </button>
          
          {showActions && (
            <div className="absolute right-0 top-8 z-10 mt-1 w-40 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
              <div className="py-1">
                {item.children && (
                  <button
                    onClick={() => {
                      setCurrentParentId(item.id);
                      setShowAddSubMenuModal(true);
                      setShowActions(false);
                    }}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                  >
                    <Plus size={16} className="mr-2" />
                    Add Submenu
                  </button>
                )}
                <button
                  onClick={() => {
                    onEdit(item);
                    setShowActions(false);
                  }}
                  className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                >
                  <Edit size={16} className="mr-2" />
                  Edit
                </button>
                <button
                  onClick={() => {
                    onDelete(item.id);
                    setShowActions(false);
                  }}
                  className="flex items-center px-4 py-2 text-sm text-red-600 hover:bg-gray-100 w-full text-left"
                >
                  <Trash2 size={16} className="mr-2" />
                  Delete
                </button>
              </div>
            </div>
          )}
        </div> */}
      </div>
      
      {item.expanded && item.children && item.children.length > 0 && (
        <div>
          {item.children.map((child) => (
            <MenuItem 
              key={child.id} 
              item={child} 
              level={level + 1}
              toggleExpand={toggleExpand}
              updatePermission={updatePermission}
              toggleEnabled={toggleEnabled}
              setCurrentParentId={setCurrentParentId}
              setShowAddSubMenuModal={setShowAddSubMenuModal}
              permissionsList={permissionsList}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </div>
      )}
    </>
  );
}